module.exports = __webpack_public_path__ + "img/resource-tech-image-23.5220879b.jpg";